var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import styles from "../../styles";
var SendMessageButton = function (props) {
    var t = useTranslation(["chat"]).t;
    return (_jsx("div", __assign({ className: "d-flex align-items-center", style: styles.buttonWrapper }, { children: _jsx("button", __assign({ className: "btn btn-primary compact", onClick: function () { return props.onClick(); } }, { children: t("Send") })) })));
};
export default SendMessageButton;
